import { render, staticRenderFns } from "./UserSelfRegister.vue?vue&type=template&id=76df73d8&"
import script from "./UserSelfRegister.vue?vue&type=script&lang=ts&"
export * from "./UserSelfRegister.vue?vue&type=script&lang=ts&"
import style0 from "./UserSelfRegister.vue?vue&type=style&index=0&id=76df73d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports